<template>
  <div>
    <div class="content">
      <LoginLogo />

      <v-form ref="form" v-bind:disabled="!getUser || !getDBUser" v-on:submit.prevent="submitForm" data-cy="----form">
        <v-container>

          <v-row no-gutters>
            Please enable multi-factor authentication.
          </v-row>

          <v-row no-gutters>
            <p style="line-height: 1.4;">
              {{$t('menus.authentication.textDescription1-1')}}
              {{$t('menus.authentication.textDescription1-2')}}
              <a href="https://authy.com/" target="_blank" style="display: inline; font-size: unset !important;">Authy.</a>
            </p>
          </v-row>

          <div class="d-flex justify-center mb-4">
            <MFAQRCode v-model:totpCode="totpCode" v-model:user="getUser">
            </MFAQRCode>
          </div>

          <div class="d-flex">
            <v-text-field
              v-bind:model-value="totpCode"
              v-bind:label="$t('menus.authentication.secretKey')"
              readonly
              variant="solo" flat
              block
            >

              <template v-slot:append>
                <v-tooltip location="bottom" z-index="1200">
                  <template v-slot:activator="{props}">
                    <v-btn tile icon v-bind="props" v-on:click="copyToClipboard(totpCode)">
                      <v-icon>mdi-clipboard-file-outline</v-icon>
                    </v-btn>
                  </template>

                  <span>{{$t('menus.authentication.copyToClipboard')}}</span>
                </v-tooltip>
              </template>

            </v-text-field>
          </div>

          <v-row no-gutters>
            <p style="line-height: 1.4;">
              {{$t('menus.authentication.textDescription2')}}
            </p>
          </v-row>

          <div class="mt-4">
            <v-text-field
              v-model="oneTimeCode"
              v-bind:label="$t('menus.authentication.oneTimeCode')"
              v-bind:rules="oneTimeCodeRules"
              prepend-inner-icon="mdi-timer-lock-outline"
              variant="solo" flat
              block
            >
            </v-text-field>
          </div>

          <div v-if="successMessage" class="bg-success" data-cy="settings-authentication-successMessage">
            {{successMessage}}
          </div>

          <div v-if="errorMessage" class="bg-error" data-cy="settings-authentication-errorMessage">
            {{errorMessage}}
          </div>

          <div class="my-4">
            <v-btn v-if="!isSubmitted" block type="submit" color="primary" v-bind:disabled="isSubmitted" >
              {{$t('menus.authentication.enableMFA')}}
            </v-btn>

            <v-btn v-if="isSubmitted" block color="primary" v-on:click="goToHome()" >
              {{$t('common.ok')}}
            </v-btn>
          </div>

        </v-container>
      </v-form>

    </div>
  </div>
</template>

<script>
import { useAuthStore } from '@/stores/AuthStore'
import LoginLogo from './components/LoginLogo.vue'
import MFAQRCode from './components/MFAQRCode.vue'
import AfterLoginMixin from './AfterLoginMixin'
import UserCalls from '@/api/modules/UserCalls.js';


export default {
  name: "AccountEnableMFA",
  mixins: [AfterLoginMixin],
  components: {
    LoginLogo,
    MFAQRCode,
  },
  data: function() {
    return {
      errorMessage: '',
      successMessage: '',

      totpCode: '',
      oneTimeCode: '',
      oneTimeCodeRules: [
        v => !!v || this.$t('menus.authentication.oneTimeCodeRequired'),
        v => /^\d{6}$/.test(v) || this.$t('menus.authentication.oneTimeCodeInvalid')
      ],

      isSubmitted: false,
    };
  },
  mounted: function() {
    this.generateTOTPCode();

    const authStore = useAuthStore();
    authStore.refreshCognitoUser();
    authStore.refreshDBUser();
  },
  methods: {
    generateTOTPCode: function() {
      let self = this;

      const authStore = useAuthStore();
      authStore.setupTOTP()
      .then(function(totp) {
        console.log("code", totp);
        self.totpCode = totp.sharedSecret;
      });
    },
    copyToClipboard: function(url) {
      if (navigator && navigator.clipboard) {
        navigator.clipboard.writeText(url)
      } else {
        // it works only on localhost and hosts with https
        // console.log("Copy not supported")
      }
    },
    submitForm: async function() {
      this.errorMessage = "";
      this.successMessage = "";

      const validForm = await this.$refs.form.validate();
      if (!validForm.valid) {
        return;
      }

      const payload = {
        code: this.oneTimeCode,
      };

      const authStore = useAuthStore();

      try {
        await authStore.verifyTOTPToken(payload);
        await authStore.enableTOTPMFA();
        await UserCalls.invalidateMfaCache().catch(console.error);
        this.successMessage = this.$t('menus.authentication.successfullyEnabled');
        this.isSubmitted = true;
      } catch (error) {
        if (error && error.message) {
          this.errorMessage = error.message;
        } else {
          this.errorMessage = "Error!";
        }
      }
    },
    goToHome: async function() {
      const authStore = useAuthStore();
      authStore.refreshCognitoUser();

      await this.afterLoginMixin();    // From the mixin
    }
  },
  computed: {
    getDBUser: function() {
      const authStore = useAuthStore();
      return authStore.dbUser;
    },
    getUser: function() {
      const authStore = useAuthStore();
      return authStore.user;
    },
  },
  watch: {
    isMFAEnabled: function(newValue) {
      if (!newValue) {
        this.generateTOTPCode();
      }

      this.errorMessage = "";
      this.successMessage = "";
      this.oneTimeCode = "";
      this.isSubmitted = false;
    }
  }
}
</script>
